import { createAsyncThunk } from "@reduxjs/toolkit";

import AlarmAPI from "~/apis/AlarmAPI";

export const getAlarmByPagination = createAsyncThunk(
  "alarms/getAlarmByPagination",
  async params => {
    const { data } = await AlarmAPI.getByPagination(params);

    return { ...data };
  }
);
